var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1.5C10.4256 1.5 13 4.07436 13 7.25C13 8.56734 12.5547 9.77947 11.8096 10.749L14.582 13.5264C14.8223 13.8209 14.8049 14.2557 14.5303 14.5303C14.2557 14.8049 13.8209 14.8223 13.5264 14.582L10.749 11.8096C9.77947 12.5547 8.56734 13 7.25 13C4.07436 13 1.5 10.4256 1.5 7.25C1.5 4.07436 4.07436 1.5 7.25 1.5ZM7.25 3C4.90279 3 3 4.90279 3 7.25C3 9.59721 4.90279 11.5 7.25 11.5C9.59721 11.5 11.5 9.59721 11.5 7.25C11.5 4.90279 9.59721 3 7.25 3Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9398ed966834d0868f05104e1fdd894b.svg";
export { ForwardRef as ReactComponent };